import * as React from 'react'

function ActivityLogImported(props) {
  return (
    <svg 
      className="icon" 
      width={20} 
      height={24} 
      viewBox="0 0 20 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      {...props}
    >
      <g transform="scale(0.85) translate(1.8, 2.1)">
        <circle cx="10" cy="6" r="3" fill="currentColor" />
        <path 
          d="M4 18C4 14.686 6.686 12 10 12C13.314 12 16 14.686 16 18V20H4V18Z" 
          fill="currentColor"
        />
        <path 
          d="M18 8L16 6L17 7H12V9H17L16 10L18 8Z" 
          fill="currentColor"
        />
        <circle cx="10" cy="14" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M10 12V16M8 14H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </g>
    </svg>
  )
}

export default ActivityLogImported
